import { Navigation } from '@noths/polaris-dev-ts-types';

const defaults: Readonly<Navigation> = {
  title: '',
  type: '',
  options: [],
};

export const navigationBuilder = (navigation?: Partial<Navigation>): Readonly<Navigation> => ({
  ...defaults,
  ...navigation,
});
